/**
 * Retry handler for API requests with exponential backoff
 */

export const retryRequest = async (
  requestFn,
  maxRetries = 3,
  baseDelay = 1000,
  requestType = "general"
) => {
  let lastError;

  // Adjust retry strategy based on request type
  let actualMaxRetries = maxRetries;
  let actualBaseDelay = baseDelay;

  if (requestType === "auth") {
    // For auth requests, reasonable retry strategy
    actualMaxRetries = 3;
    actualBaseDelay = 1000; // Start with 1 second
  }

  for (let attempt = 0; attempt <= actualMaxRetries; attempt++) {
    try {
      return await requestFn();
    } catch (error) {
      lastError = error;

      // Only retry on 429 (rate limit) or 5xx (server) errors
      if (
        error.response?.status === 429 ||
        (error.response?.status >= 500 && error.response?.status < 600)
      ) {
        if (attempt < actualMaxRetries) {
          const delay = actualBaseDelay * Math.pow(2, attempt); // Exponential backoff
          console.log(
            `Request failed (attempt ${attempt + 1}/${actualMaxRetries + 1}), retrying in ${delay}ms...`
          );
          await new Promise((resolve) => setTimeout(resolve, delay));
          continue;
        }
      }

      // Don't retry for other errors
      throw error;
    }
  }

  throw lastError;
};

export default retryRequest;
